import { defineComponent as m, openBlock as e, createElementBlock as n, createBlock as c, resolveDynamicComponent as a, toRaw as u, createCommentVNode as d, Fragment as f, renderList as I, normalizeClass as k } from "vue";
const y = ["id"], x = {
  key: 1,
  class: "w-full list-none"
}, h = ["id"], w = /* @__PURE__ */ m({
  name: "RevCarouselItems",
  __name: "CarouselItems",
  props: {
    currentIndex: {},
    currentIndexId: {},
    items: {}
  },
  setup(t) {
    const s = t;
    function l(o) {
      return o === s.currentIndex;
    }
    return (o, C) => t.items.length === 1 ? (e(), n("div", {
      key: 0,
      id: s.currentIndexId,
      class: "flex w-full justify-center motion-safe:animate-fade-in"
    }, [
      t.items[0] !== null ? (e(), c(a(u(t.items[0])), { key: 0 })) : d("", !0)
    ], 8, y)) : (e(), n("ul", x, [
      (e(!0), n(f, null, I(t.items, (i, r) => (e(), n("li", {
        id: l(r) ? s.currentIndexId : void 0,
        key: r,
        class: k(["flex w-full list-none justify-center motion-safe:animate-fade-in", l(r) ? "block" : "hidden"])
      }, [
        i !== null ? (e(), c(a(u(i)), { key: 0 })) : d("", !0)
      ], 10, h))), 128))
    ]));
  }
});
export {
  w as default
};
